import { render, staticRenderFns } from "./VimeoPlayer.vue?vue&type=template&id=2b6389ec&scoped=true&"
import script from "./VimeoPlayer.vue?vue&type=script&lang=js&"
export * from "./VimeoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./VimeoPlayer.vue?vue&type=style&index=0&id=2b6389ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6389ec",
  null
  
)

export default component.exports